exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-4e974e8a]{margin:0;padding:0}#app[data-v-4e974e8a],.app-container[data-v-4e974e8a],body[data-v-4e974e8a],html[data-v-4e974e8a]{width:100%;height:100%}.app-container[data-v-4e974e8a]{position:relative}", ""]);

// exports
